import React, { useState } from 'react';
import Icon from '../Icon/Icon';
import styles from './TextWithInfo.module.scss';
import cx from 'classnames';

const TextWithInfo = ({ text, infoText, className, infoClassName }) => {
  const [isHover, setIsHover] = useState(false);

  return (
    <div className={cx(styles.wrapper, className)}>
      <span className={styles.text}>{text}</span>
      {infoText && (
        <>
          <Icon
            src="additionalInfo"
            className={styles.infoIcon}
            onMouseOver={() => setIsHover(true)}
            onMouseOut={() => setIsHover(false)}
          />
          {isHover && <div className={cx(styles.infoText, infoClassName)}>{infoText}</div>}
        </>
      )}
    </div>
  );
};

export default TextWithInfo;
